import {useEffect, useRef, useState} from "react";
import {SFuncModal, SGeneralForms} from "shj-components";
import {batchSaveTags, updateTagTypeOrTag} from "@/services/customerServices";
import {message, Input} from "antd";
import {isEmpty} from "lodash-es";
import {trimStr} from "@/utils/data.ts";

interface IProps {
  editRef: any,
  selectedType?: Record<string, any>
  record?: Record<string, any>
  reload: () => void
  onClose: () => void
}

export const AddOrEditTagModal = (props: IProps) => {
  const ref = useRef()
  const {editRef, record, selectedType} = props;
  const [loading, setLoading] = useState(false)
  const [baseFormData, setBaseFormData] = useState<any>({
    groupTag: 'tag',
    source: 'tenant',
    tagType: 'custom'
  })

  useEffect(() => {
    if (record) {
      const newData = {...record, ...record.object};
      // console.log(newData, 'newData')
      ref.current?.onFormRef()?.setFieldsValue(newData)
    }
  }, [record]);

  useEffect(() => {
    if (selectedType && !isEmpty(selectedType)) {
      setBaseFormData({...baseFormData, pid: selectedType.id, weight: selectedType.object.weight + 1});
    }
  }, [selectedType]);

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      ref.current?.onFormRef()?.validateFields()
          .then((values) => {
            setLoading(true)
            const apiFn = values.id ? updateTagTypeOrTag : batchSaveTags;
            const params = values.id ? {...values, ...baseFormData} : values.tagList.map(item => ({...item, ...baseFormData}))
            apiFn({data: params}).then(() => {
              message.success('操作成功');
              props.reload?.()
              resolve();
            }).finally(() => setLoading(false))
          })
          .catch(reject);
    });
  }

  const onReset = () => {
    ref.current?.onFormRef()?.resetFields();
    ref.current?.onFormRef()?.setFieldsValue({tagList: {}})
  }

  if (editRef) {
    editRef.current.onFinish = onFinish
    editRef.current.onReset = onReset
  }

  return <SFuncModal.Content
      onCancel={props.onClose}
      onOk={onFinish}
      confirmLoading={loading}
  >
  <SGeneralForms
      ref={ref}
      initialValues={{tagList: [{}]}}
      layout={'vertical'}
      configs={[{
        type: record?.id ? '' : 'multiple',
        formName: 'tagList',
        layoutRowStyle: { padding:'0px'},
        formItem: [
          {name: 'id', label: 'id', hidden: true},
          {name: 'weight', label: '级别', spanCol: 24, hidden: true},
          {
            name: 'name', label: '标签', spanCol: 24,
            required: true,
            rules: [{required: true, message: '标签不能为空'}],
            children: (formRef, formItem, key) => <Input
                maxLength={20}
                showCount
                onChange={(e) => {
                  const tagList = formRef.getFieldValue('tagList')
                  formRef.setFieldValue('tagList', tagList.map(item => ({...item, name: trimStr(item.name)})))
                }}/>
          }]
      }]}
  />
  </SFuncModal.Content>
}